import { regionApi, regionRequest } from './regionApi';

export const regionHaSnapshotApi = regionApi.injectEndpoints({
  endpoints: (build) => ({
    /* -------------------------------------------------- */
    /* Snapshot list                                     */
    /* -------------------------------------------------- */
    getHaSnapshotList: build.query<any, Record<string, any>>({
      query: ({ region, account, instance }) =>
        regionRequest(region, 'instance/snapshot_list', {
          method: 'POST',
          body: {
            group_id: account?.group_id,
            account_id: account?.account_id,
            instance_id: instance?.instance_id,
            user_id: account?.user_id,
            access_from_user_id: account?.access_from_user_id
          }
        }),

      providesTags: (_result, _error, arg) => [
        {
          type: 'Snapshot',
          id: arg?.instance?.instance_id
        }
      ]
    }),

    /* -------------------------------------------------- */
    /* Create snapshot                                   */
    /* -------------------------------------------------- */
    createHaSnapShot: build.mutation<any, Record<string, any>>({
      query: ({
        region,
        group_id,
        account_id,
        instance_id,
        user_id,
        access_from_user_id,
        snapshot_name,
        desc
      }) =>
        regionRequest(region, 'instance/create_snapshot', {
          method: 'POST',
          body: {
            group_id,
            account_id,
            instance_id,
            user_id,
            access_from_user_id,
            snapshot_name: snapshot_name || '',
            desc: desc || ''
          }
        })
    }),

    /* -------------------------------------------------- */
    /* Revert snapshot                                   */
    /* -------------------------------------------------- */
    revertHaSnapShot: build.mutation<any, Record<string, any>>({
      query: ({
        region,
        group_id,
        account_id,
        instance_id,
        user_id,
        access_from_user_id,
        snapshot_id
      }) =>
        regionRequest(region, 'instance/revert_snapshot', {
          method: 'POST',
          body: {
            group_id,
            account_id,
            instance_id,
            user_id,
            access_from_user_id,
            snapshot_id: snapshot_id || ''
          }
        })
    })

    /* -------------------------------------------------- */
  }),

  overrideExisting: false
});

export const {
  useGetHaSnapshotListQuery,
  useCreateHaSnapShotMutation,
  useRevertHaSnapShotMutation
} = regionHaSnapshotApi;
